
import React, { useState } from 'react';
import check from 'images/check.png';
import avatar1 from 'images/avatar-1.png';
import avatar2 from 'images/avatar-2.png';
import bookCover from 'images/book-cover.png';
import ModalEmail from 'components/ModalEmail';

import * as S from './styles';

function SectionOne() {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    setShowModal(prev => !prev);
  }

  return (
    <S.Wrapper>
      <div className='title-header'>
        <div className='d-grid'>
          <div className='div-block-red' />
          <S.Content>
            <h2>
              <span>Affiliate Marketers:</span> <br />
              Did You Get The Largest Affiliate Report of 2022?
            </h2>
          </S.Content>
          <div />
        </div>
      </div>
      <section>
        <article>

          <S.Content>

            <h1>
              What's Working in
              <br />
              Affiliate Marketing <span className='red'>2022</span>
            </h1>
            <ul className="list-content">
              <li>
                <img src={check} alt="" />
                <p>
                  How the Biggest Names in the Industry are Making Their Profits
                </p>
              </li>
              <li>
                <img src={check} alt="" />
                <p>
                  Secrets to Success: From Super-Affiliates to Ecom Experts
                </p>
              </li>
              <li>
                <img src={check} alt="" />
                <p>Gold Intel from Top Spy Tools</p>
              </li>
              <li>
                <img src={check} alt="" />
                <p>
                  Covid's Impact on the Industry
                </p>
              </li>
              <li>
                <img src={check} alt="" />
                <p>What's Working on Tiktok, Facebook, Native, Google, Push, Pop, and more</p>
              </li>
              <li>
                <img src={check} alt="" />
                <p>Best Advice for Newbies Starting Out in Year 2022</p>
              </li>
            </ul>
            <S.SubmitBtn data-id="bY16" onClick={openModal}>EMAIL ME THE FREE REPORT NOW</S.SubmitBtn>
            <ModalEmail showModal={showModal} setShowModal={setShowModal} />
            <ul className="info-links">
              @2022 STM Forum.&nbsp;
              <li>
                <a href="https://stmforum.com/" target="blank">
                  <button>
                    About STM
                  </button>
                </a>
              </li>
              <li>
                <a href="https://stmforum.com/privacy.html" target="blank">
                  <button>
                    Privacy Policy
                  </button>
                </a>
              </li>
              <li>
                <a href=" https://stmforum.com/earnings-disclaimer.html" target="blank">
                  <button>
                    Earning Disclaimer
                  </button>
                </a>
              </li>
              <li>
                <span>
                &nbsp;|&nbsp;&nbsp;&nbsp;Questions?
                </span>
              </li>
              <li>
                <a href="mailto:info@stmforum.com">
                  <button>
                    info@stmforum.com
                  </button>
                </a>
              </li>
            </ul>
          </S.Content>
        </article>
        <aside>
          <S.Testimonial>
            <div className="item">

              <p>
                "I'm absolutely certain we raised the bar with this year's
                report again. With 300+ pages of pure goodness from the
                brightest minds in affilaite marketing, it's the most
                compehensive report this industry has ever seen!"
              </p>
              <div className='author'>
                <img src={avatar1} alt="" />
                <small>
                  <strong>MATEJ CECHVALA (aka Matuloo)</strong>
                  <br /> Senior STM Forum Moderator <br />
                  Matuloo.com
                </small>
              </div>
            </div>
            <div className="item">

              <p>
                "For anyone who's wondering what the most successful affiliate
                and ecom entrepreneurs are doing in 2022 - READ THIS REPORT!"
              </p>
              <div className='author'>
                <img src={avatar2} alt="" />
                <small>
                  <strong>AMY CHEUNG (aka Vortex)</strong>
                  <br /> Senior STM Forum Moderator
                </small>
              </div>
            </div>
          </S.Testimonial>
        </aside>
      </section>
      <img src={bookCover} alt="" className="book-cover" />
    </S.Wrapper>
  );
}

export default SectionOne;
